
@if (isGroupTagsAndSingleTags()) {
  <app-tags-group-list [tagsGroupList]="tags().groups" />
  <app-single-tags 
    [singleTagList]="tags().singleTags" 
    [isOnlySingleTags]="isOnlySingleTags()"
  />
  
} @else if(isOnlyGroupTags()) {
  <app-tags-group-list [tagsGroupList]="tags().groups" />
  
} @else if(isOnlySingleTags()) {
  <app-single-tags 
    [singleTagList]="tags().singleTags" 
    [isOnlySingleTags]="isOnlySingleTags()"
  />
}